import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

export default function AdminPublicRoute({ children }) {
  const isloggedIn = useAuth();
  const auth = useSelector((state) => state.auth);

  return !isloggedIn ? (
    // if not loggedIn show children
    children
  ) : auth.user.role === "admin" ? (
    // if logged in but user is an admin then show admin dashboard page
    <Navigate to="/admin/dashboard" />
  ) : (
    // if logged in but user is a student then show student courseplayer page
    <Navigate to="/coursePlayer" />
  );
}
